
  import ipxRuntime$V9kY778XHa5K7VNanIVgnU3oFE8EPCFelL4ug8iMbQ8 from '/builds/contelizer-easyitem-com/prestashop-rest-front/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_better-sqlite3@11.10.0__ioredis@5.10.1_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xs": 320,
    "xxl": 1536,
    "3xl": 1700
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "images.lavmag.eu",
    "images.youlook.example",
    "lavmag.eu",
    "www.lavmag.eu",
    "localhost",
    "127.0.0.1"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 95
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$V9kY778XHa5K7VNanIVgnU3oFE8EPCFelL4ug8iMbQ8, defaults: {} }
    }
  }
